import { cloudFunction } from 'services/parse';

export const fetchAllUserCarts = async (params: any) => {
  return cloudFunction('fetchAllUserCarts', params);
};

export const quoteCartByAdmin = async (params: any) => {
  return cloudFunction('quoteCartByAdmin', params);
};

export const fetchUserCartDetails = async (params: any) => {
  return cloudFunction('fetchUserCartDetails', params);
};

export const processCart = async (params: any) => {
  return cloudFunction('processCart', params);
};

export const quoteCart = async (params: any) => {
  return cloudFunction('quoteCart', params);
};

export const removeItemFromCart = async (params: any) => {
  return cloudFunction('removeItemFromCart', params);
};
